import { mergeAttributes, Node } from '@tiptap/core';
import { ReactNodeViewRenderer } from '@tiptap/react';
import BlockFileCardComponent from '../components/BlockFileCard';

export const BlockFileCard = Node.create({
  name: 'blockFileCard',
  group: 'block',
  content: '',
  draggable: true,

  addAttributes() {
    return {
      name: { default: '' },
      type: { default: '' },
      size: { default: 0 },
      url: { default: '' },
      date: { default: '' },
    };
  },

  parseHTML() {
    return [{ tag: 'div[node-type="block-file-card"]' }];
  },

  renderHTML({ HTMLAttributes }) {
    return [
      'div',
      mergeAttributes(HTMLAttributes, { 'node-type': 'block-file-card' }),
    ];
  },

  addNodeView() {
    return ReactNodeViewRenderer(BlockFileCardComponent);
  },
});
